import type { PageableRangeInput } from '@allocab/allocab-extranet-api-types';
import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetIncidentOutput, ExtranetIncidentsListInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { toPageableRangeInput } from '../mappers';
import { extranetQueryKeys } from '../queryKeys';

// `search`, `sortBy`, `sortDir`, `status[]`, `category[]`, `priority[]` ne sont
// pas (encore) supportés par /v1/incidents/ : on les conserve dans l'input
// front pour stabilité d'API et tri/filtre client, mais ils sont ignorés côté
// call API.
//
// Note : le shape ExtranetIncidentOutput inclut déjà ride/timeline/attachments
// inline — donc plus besoin d'un endpoint detail séparé.
export const useExtranetIncidentsList = (input: ExtranetIncidentsListInput) =>
  useQuery<ListOutput<ExtranetIncidentOutput>>({
    queryKey: extranetQueryKeys.incidents.list(input),
    queryFn: () =>
      getExtranetApi().get<PageableRangeInput, ListOutput<ExtranetIncidentOutput>>(
        '/v1/incidents/',
        toPageableRangeInput(input, {
          offset: input.page && input.limit ? (input.page - 1) * input.limit : undefined,
          limit: input.limit,
        }),
      ),
    enabled: Boolean(input.dateRange?.from && input.dateRange?.to),
    placeholderData: keepPreviousData,
  });
